<template>
    <div id="systemOptimization">
        <p class="serviceTitle"><span>系统优化</span></p>
        <ul id="optimizationWrapper">
            <li>
                <div class="systemImg">
                    <img src="../../../assets/imgs/service/sys1.png">
                </div>
                <div class="systemText">
                    <p>供水管网区块化管理</p>
                    <div>
                        天津三博专家为供水企业提供供水管网区块化管理的全面解决方案。通过建立管网水力模型，制定科学合理的分区方案。区块化管理可均衡管网压力，显著降低管网漏失率，降低产销差，减小水龄，保障管网水质，从根本上提高供水企业的管理水平，保障供水的安全可靠性。
                    </div>
                </div>
            </li>
            <li>
                <div class="systemImg">
                    <img src="../../../assets/imgs/service/sys2.png">
                </div>
                <div class="systemText">
                    <p>降低供水产销差</p>
                    <div>
                        天津三博水科技公司通过建立供水管网水力模型，对整个供水网络进行建模，并从SCADA系统获取管网的实时信息进行实时模拟，将监测、设计，模型管理，泄漏管理，调度，施工维护，信息管理和专家系统等各职能进行整合，形成适合供水企业日常运营的全面高效管理平台，有效降低产销差
                    </div>
                </div>
            </li>
            <li>
                <div class="systemImg">
                    <img src="../../../assets/imgs/service/sys3.png">
                </div>
                <div class="systemText">
                    <p>提高供水管网水质</p>
                    <div>
                        天津三博通过建立管网动态水质模型，预测管网水质随空间和时间的变化规律，实时模拟管网的水质状况，为改善管网水质提供科学的依据。三博能够帮助供水企业有效减少管网二次污染，提高供水安全性。
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'List4',
}
</script>

<style scoped>
    #optimizationWrapper{
        width: 1120px;
        margin: 0 auto;
    }
    #optimizationWrapper>li{
        margin-bottom: 15px;
    }
    #optimizationWrapper>li:last-child{
        margin-bottom: 0;
    }
    .systemImg{
        float: left;
        width: 220px;
        height: 171px;
        border: 1px solid #b0b0b0;
    }
    .systemImg>img{
        width: 100%;
        height: 100%;
    }
    .systemText{
        margin-left: 220px;
        padding: 31px 40px;
        background: #efefef;
    }
    .systemText>p{
        font-weight: bold;
        margin-bottom: 20px;
    }
    .systemText>div{
        color:#221815;
        text-indent: 28px;
        line-height: 24px;
        height: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;     /*设置行数*/
        -webkit-box-orient: vertical;
    }
</style>
